import React, { useEffect, useRef, useState } from 'react';
import { useAlert } from 'react-alert';
import useAuthz from '../../hooks/useAuthz';
import { TextField } from '@mui/material';
import MyButton from '../Layout/MyButton';
import AgGrid from '../AgGrid/AgGrid';
import axios from 'axios';
import { URL_API } from '../../utils/globalConfig';
import { logError } from '../Utils/FormatData';
import CheckboxRender from '../AgGrid/CheckboxRenderer';
import { useNavigate } from 'react-router';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { REGEX_PR } from '../../constants/enum';

const elemPatriColumns = (props, setGridSelectedValues) => {
  return [
    {
      headerName: 'id',
      field: 'id_oa',
      sortable: true,
      minWidth: 85,
      flex: 1,
      maxWidth: 200,
      autoHeight: true,
      filter: 'agTextColumnFilter',
    },
    {
      headerName: 'description',
      field: 'description',
      width: 300,
      sortable: true,
      autoHeight: true,
      wrapText: true,
      filter: 'agTextColumnFilter',
    },
    {
      headerName: 'Type EP',
      field: 'type',
      flex: 1,
      sortable: true,
      minWidth: 100,
      autoHeight: true,
      filter: 'agSetColumnFilter',
      filterParams: {
        selectAllOnMiniFilter: true,
      },
    },
    {
      headerName: 'Info EP',
      flex: 1,
      field: 'info',
      sortable: true,
      minWidth: 100,
      autoHeight: true,
      filter: 'agTextColumnFilter',
    },
    { headerName: 'axe', field: 'linkedAxis', flex: 1, sortable: true, maxWidth: 80, autoHeight: true, filter: 'agTextColumnFilter' },
    {
      headerName: 'sens',
      flex: 1,
      field: 'direction',
      sortable: true,
      maxWidth: 80,
      autoHeight: true,
      filter: 'agNumberColumnFilter',
      filterParams: { includeBlanksInEquals: true, includeBlanksInLessThan: true, includeBlanksInGreaterThan: true, includeBlanksInRange: true, }
    },
    {
      headerName: 'pk',
      flex: 1,
      field: 'landmark',
      sortable: true,
      sort: 'asc',
      autoHeight: true,
      filter: 'agNumberColumnFilter',
      comparator: function (valueA, valueB) {
        return Number(valueA) - Number(valueB);
      }, filterParams: { includeBlanksInEquals: true, includeBlanksInLessThan: true, includeBlanksInGreaterThan: true, includeBlanksInRange: true, }
    },
    { headerName: 'HAUTEUR', field: 'airPulling', flex: 1, sortable: true, autoHeight: true, filter: 'agNumberColumnFilter', filterParams: { includeBlanksInEquals: true, includeBlanksInLessThan: true, includeBlanksInGreaterThan: true, includeBlanksInRange: true, }
    },
    { headerName: 'LONGUEUR', field: 'length', flex: 1, sortable: true, autoHeight: true, filter: 'agNumberColumnFilter', filterParams: { includeBlanksInEquals: true, includeBlanksInLessThan: true, includeBlanksInGreaterThan: true, includeBlanksInRange: true, } },
    { headerName: 'LARGEUR', field: 'width', flex: 1, sortable: true, autoHeight: true, filter: 'agNumberColumnFilter', filterParams: { includeBlanksInEquals: true, includeBlanksInLessThan: true, includeBlanksInGreaterThan: true, includeBlanksInRange: true, } },
    { headerName: 'PTAC_max', field: 'weight', flex: 1, sortable: true, autoHeight: true, filter: 'agNumberColumnFilter', filterParams: { includeBlanksInEquals: true, includeBlanksInLessThan: true, includeBlanksInGreaterThan: true, includeBlanksInRange: true, } },
    { headerName: 'PTAC_MAX_GRUE', field: 'ptac_grue', flex: 1, sortable: true, autoHeight: true, filter: 'agNumberColumnFilter', filterParams: { includeBlanksInEquals: true, includeBlanksInLessThan: true, includeBlanksInGreaterThan: true, includeBlanksInRange: true, } },
    { headerName: 'IGM', field: 'iti_grd_maille', sortable: true, filter: 'agNumberColumnFilter', filterParams: { includeBlanksInEquals: true, includeBlanksInLessThan: true, includeBlanksInGreaterThan: true, includeBlanksInRange: true, } },
    {
        headerName: 'PTAC/IGM',
        field: 'rapport_ptac_max',
        sortable: true,
        filter: 'agNumberColumnFilter',
        valueGetter: (params) => {
            let calcul = null;
            if (params.data.iti_grd_maille > 0) {
                calcul = params.data.weight / params.data.iti_grd_maille;
            }
            return calcul ?? '-';
        }, filterParams: { includeBlanksInEquals: true, includeBlanksInLessThan: true, includeBlanksInGreaterThan: true, includeBlanksInRange: true, }
    },
    { headerName: 'centre', field: 'center', sortable: true, filter: 'agSetColumnFilter', filterParams: {
              selectAllOnMiniFilter: true,
          },
      },
    { headerName: 'commune', field: 'commune', sortable: true, filter: 'agTextColumnFilter' },
    {
      headerName: 'actions',
      field: 'selected',
      width: 100,
      sortable: false,
      autoHeight: true,
      cellRenderer: 'checkRenderer',
      cellRendererParams: {
        setGridSelectedValues: setGridSelectedValues,
      },
      pinned: 'right',
    },
  ];
};
const demandePassageStyle = {
  textField: { width: '50%', margin: '20px' },
  textFieldShort: { width: '25%', margin: '20px' },
  textFieldFixed: { maxWidth: '200px', margin: '20px' },
};

const RechercheElemPatri = (props) => {
  const refs = useRef([]);
  const grid = useRef();
  const navfigate = useNavigate();
  const alert = useAlert();
  const [authz, user, profil] = useAuthz();
  const [isLoading, setIsLoading] = useState(true);
  const [gridSelectedValues, setGridSelectedValues] = useState([]);
  const [selectedValues, setSelectedValues] = useState([]);
  const frameworkComponents = {
    'checkRenderer': CheckboxRender,
  };
  const [agGridOptions, setAgGridOptions] = useState({
    suppressCellSelection: true,
    suppressHorizontalScroll: false,
    animateRows: true,
  });
  const [elementsPatri, setElementsPatri] = useState([{
    axis: '',
    department: '',
    description: '',
    direction: 0,
    id: 0,
    landmark: 0,
    latitude: 0,
    longitude: 0,
    type: '',
    selected: false,
  }]);
  const [filters, setFilters] = useState({
    type: null,
    passType: null,
    passTypeText: null,
    axis: null,
    linkedAxis: null,
    direction: null,
    department: null,
    prStart: null,
    prEnd: null,
    prScaleSearch: null,
  });
  const [checkAll, setCheckAll] = useState(false);

  //#region useEffect

  useEffect(() => {
    if (profil.profil === 6) {
      alert.error(`Vous n'êtes pas autorisé à accéder à la liste des dossiers`);
      navigate('/');
    } else {
      callApis();
    }
  }, []);
  useEffect(() => {
    let data = [];
    gridSelectedValues.forEach(function(gridSelectedValue) {
      data.push(gridSelectedValue);
    });

    setSelectedValues(data);

  }, [gridSelectedValues]);
  useEffect(() => {
    if (elementsPatri.length > 0) {
      setFilters({
        ...filters,
        passType: props.elemPatri.descr.passType,
        type: props.elemPatri.descr.passType,
        axis: props.elemPatri.passType === "autoroute" ? props.elemPatri.descr.axeSectionEnter : props.elemPatri.descr.road,
        linkedAxis: props.elemPatri.passType === "autoroute" ? props.elemPatri.descr.axeSectionEnter : props.elemPatri.descr.road,
        direction: Number(props.elemPatri.descr.sensSectionEnter),
        department: Number(props.elemPatri.descr.departmentSectionEnter),
        prStart: Number(props.elemPatri.descr.prSectionEnter),
        prEnd: Number(props.elemPatri.descr.prSectionExit),
        prScaleSearch: Number(10),
      });

      // document.getElementById("axisTextField").dispatchEvent(new Event("change"))
    }
  }, [elementsPatri]);

  //#endregion

  //#region Functions

  const onCheckboxChange = () => {
    setCheckAll(!checkAll);
  };
  const onCloseElemPatri = (withData = false) => {
    props.elemPatri.descr.elemPatri.map((elem, i) => {
      let elemPatri = selectedValues.find((e) => e.id === elem.id);
      if (elemPatri) {
        elemPatri.status = elem.status;
      }
    });

    props.setElemPatri({ ...props.elemPatri, isOpen: false });

    if (withData) {
      let descr = props.elemPatri.descr;
      selectedValues.forEach((elem) => {
        if (!elem.status) {
          elem.status = 'unknown';
        }
      });
      descr.elemPatri = selectedValues;
      props.setElemPatri({ ...props.elemPatri, isOpen: false, descr: descr });
    }

    setSelectedValues([]);
  };
  const handleFilterChange = (e, pattern = null) => {
    if (pattern) {
      const regex = new RegExp(pattern);
      if (e.target.value === '' || regex.test(e.target.value)) {
        setFilters({ ...filters, [e.target.name]: e.target.value.toUpperCase() });
      }
    } else {
      setFilters({ ...filters, [e.target.name]: e.target.value });
    }
  };
  const callApis = () => {
    setIsLoading(true);

    axios({
      method: 'get',
      url: `${URL_API}/element-patrimoine/base-sig`,
    })
      .then((response) => {
        setIsLoading(false);
        let preselectedData = [];
        let data = (response) => {
          response.data.forEach(function(datum) {
            datum.selected = false;

            props.elemPatri.descr.elemPatri.forEach(function(elem) {
              if (datum.id === elem.id) {
                preselectedData.push(datum);
                datum.selected = true;
              }
            });
          });

          return response.data;
        };
        setSelectedValues(preselectedData);
        setElementsPatri(data(response));
      })
      .catch((error) => {
        setIsLoading(false);
        logError(alert, error);
      });
  };

  //#endregion

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <h3 className='modal-step-title'>Éléments de patrimoine</h3>

        <div className='row' style={{ flexWrap: 'nowrap', justifyContent: 'left', height: 'calc(15% + 10px)' }}>
          <TextField
            id={'axisTextField'}
            label='AXE'
            type='text'
            name='linkedAxis'
            value={filters.linkedAxis || ''}
            style={demandePassageStyle.textField}
            autoComplete='off'
            onChange={(e) => handleFilterChange(e)}
            inputProps={{ maxLength: 5 }}
          />
          <TextField
            label='SENS'
            type='text'
            name='direction'
            value={filters.direction || ''}
            style={demandePassageStyle.textField}
            autoComplete='off'
            onChange={(e) => handleFilterChange(e)}
            inputProps={{ maxLength: 1 }}
          />
          <TextField
            label='PR DÉBUT'
            type='text'
            name='prStart'
            value={filters.prStart || ''}
            style={demandePassageStyle.textField}
            autoComplete='off'
            onChange={(e) => handleFilterChange(e, REGEX_PR)}
            placeholder={'000.0000'}
            inputProps={{ maxLength: 8 }}
          />
          {
            props.trjtType === 'autoroute' &&
            <TextField
              label='PR FIN'
              type='text'
              name='prEnd'
              value={filters.prEnd || ''}
              style={demandePassageStyle.textField}
              autoComplete='off'
              onChange={(e) => handleFilterChange(e, REGEX_PR)}
              placeholder={'000.0000'}
              inputProps={{ maxLength: 8 }}
            />
          }
          {
            props.trjtType === 'superieur' &&
            <TextField
              label='ECHELLE DE RECHERCHE (KM)'
              type='text'
              name='prScaleSearch'
              value={filters.prScaleSearch || ''}
              style={demandePassageStyle.textField}
              autoComplete='off'
              onChange={(e) => handleFilterChange(e)}
              inputProps={{ maxLength: 3 }}
            />
          }
        </div>
        <div style={{ height: '90%' }}>
          <div style={{ height: '100%', width: '100%', borderTop: '1px solid #4db4da' }}>
            <AgGrid
              gridName='ag-grid-heritage-element'
              rowData={elementsPatri}
              columnDefs={elemPatriColumns(props, setGridSelectedValues)}
              rowHeight={70}
              pagination={true}
              paginationPageSize={25}
              frameworkComponents={frameworkComponents}
              gridOptions={agGridOptions}
              setGridOptions={setAgGridOptions}
              sortable={false}
              filters={filters}
              checkAll={checkAll}
              setGridSelectedValues={setGridSelectedValues}
            />
          </div>
        </div>
        <div>
          <div className='row'
               style={{
                 justifyContent: 'flex-end',
                 alignItems: 'center',
                 height: '80px',
                 marginRight: '55px',
                 marginTop: '-50px',
                 fontWeight: 'bold',
               }}
          >
            <label>Tout cocher</label>
            <input
              type='checkbox'
              onChange={onCheckboxChange}
              checked={checkAll}
            />
          </div>

          <div className='row'
               style={{ justifyContent: 'flex-end', alignItems: 'center', height: '80px' }}
          >
            <MyButton
              onClick={() => {
                onCloseElemPatri();
              }}
              style={'buttonCloseModal'}
              label={'Annuler'}
            />
            <MyButton
              onClick={() => {
                onCloseElemPatri(true);
              }}
              style={'buttonValidation'}
              label={'Valider la sélection'}
              icon={faCheck}
            />
          </div>
        </div>
      </div>
    </>
  );

};

export default RechercheElemPatri;